import theme from '@theme';
import React, { CSSProperties } from 'react';
import renderSkeletons from './renderSkeltons';
import styled from 'styled-components';

const AddressInformationsSkeleton: React.FC = () => {
  const firstRowSkeletons = [
    { width: 8, height: 8, baseColor: theme.palette.grey[200], borderRadius: 2 },
    {
      width: 138,
      height: 8,
      baseColor: theme.palette.grey[200],
      borderRadius: 5,
      className: 'mx-2'
    }
  ];

  const secondRowSkeletons = [
    { width: '100%', height: 30, baseColor: theme.palette.grey[100], borderRadius: 5 },
    {
      width: 139,
      height: 18,
      baseColor: theme.palette.grey[200],
      borderRadius: 3,
      className: 'mx-2',
      style: { position: 'absolute' as CSSProperties['position'], top: '0.625rem', right: '0.3rem' }
    }
  ];

  return (
    <SkeletonWrapper>
      <div className="d-flex align-items-center">{renderSkeletons(firstRowSkeletons)}</div>
      <div className="position-relative">{renderSkeletons(secondRowSkeletons)}</div>
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div`
  br {
    display: none;
  }
`;

export default AddressInformationsSkeleton;
